// extracted by mini-css-extract-plugin
module.exports = {"arquivos":"Anexos_arquivos__2pOnQ"};